import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 10,
	viewBox: "0 0 12 10",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.2754 0.916668L11.8333 2.4186L4.31516 9.66667L0.166626 5.66715L1.72452 4.16522L4.31516 6.6628L10.2754 0.916668Z",
		fill: "currentColor"
	})
});
export default SvgCheck;
